export default __webpack_public_path__ + "static/media/device_health_monitoring_line_mobile.4bdbe0b9.svg";